exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-sidenav {\n  padding: 20px;\n  border-radius: 1px; }\n\na img {\n  max-width: 80px;\n  max-height: 80px;\n  width: auto;\n  height: auto; }\n\n.example-sidenav-content {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background: white; }\n\nmat-drawer-container {\n  height: 100%; }\n\nmat-drawer p button {\n  max-width: 250px;\n  width: 200px; }\n\n.menu {\n  position: absolute;\n  top: 10px;\n  left: 0; }\n\na, h2 {\n  display: inline-block; }\n\nh1 {\n  color: #0B5445;\n  font-size: 21px;\n  font: Poppins; }\n\nspan {\n  font-size: 12px;\n  font: Poppins; }\n\n.footer {\n  color: #607D8B; }\n\n.nameUser {\n  font-size: 20px;\n  font-weight: bold; }\n\nfooter {\n  position: fixed;\n  bottom: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/assinatura-eletronica/assinatura-eletronica.component.scss
// module id = ../../../../../src/app/components/assinatura-eletronica/assinatura-eletronica.component.scss
// module chunks = main